var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',{staticClass:"date-picker",attrs:{"min":_vm.minDate,"max":_vm.maxDate,"locale":_vm.$i18n.locale,"color":"primary"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }